import React from 'react';
import './PolicyPatriotismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {
  POLICY_PATRIOTISM_BUILDING_DISCOUNT_ARSENAL,
  POLICY_PATRIOTISM_UNIT_SIZE_DISCOUNT,
} from "../../../../configs/policy/patriotism";

const PolicyPatriotismDescription = () => {
  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const unitSizeIcon = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  const arsenal = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/arsenal.7f5423b5.png'}
    alt={'Арсенал'}
    title={'Арсенал'}
  />;

  const sizeDiscount =
    <CoinsStat
      text={POLICY_PATRIOTISM_UNIT_SIZE_DISCOUNT}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  const arsenalDiscount =
    <CoinsStat
      text={POLICY_PATRIOTISM_BUILDING_DISCOUNT_ARSENAL}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left'}
    />;

  return (
    <>
      <div className={'policy-description_line'}>
        Найм {unitSizeIcon} дешевле {discountElement} на {sizeDiscount}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        {arsenal} дешевле {discountElement} на {arsenalDiscount}.
      </div>
    </>
  );
};

export default PolicyPatriotismDescription;
